export default class TitleRenderer {
  eGui

  init(params) {
    const divMain = document.createElement('div')
    const divTitle = document.createElement('div')
    const divCity = document.createElement('div')
    divTitle.innerHTML = params.data.title
    divCity.innerHTML = params.data.city
    divCity.style.color = '#928e93'
    divMain.appendChild(divTitle)
    divMain.appendChild(divCity)
    this.eGui = divMain
  }

  getGui() {
    return this.eGui
  }
}
